import { useEffect, useState } from 'react';

export const GOOGLE_OPTIMIZE_CTA_BUTTON_TEST_ID = 'e7hdhOuQQiO9J6A4NbAbVA';
import { GOOGLE_OPTIMIZE_INTRO_STEP_TEST_ID } from 'pages/vertical';
import { GOOGLE_OPTIMIZE_HERO_IMAGE_TEST_ID } from 'src/modules/common/components/Jumbotron';
import { GOOGLE_OPTIMIZE_REQUEST_FORM_BLOCKING_API_CALL_TEST_ID } from 'src/modules/requests/service';

/**
 * If you are doing AB testing, put the ExperimentID in this array.
 */
export const OPTIMIZE_TEST_ID_LIST = [
  GOOGLE_OPTIMIZE_CTA_BUTTON_TEST_ID,
  GOOGLE_OPTIMIZE_INTRO_STEP_TEST_ID,
  GOOGLE_OPTIMIZE_HERO_IMAGE_TEST_ID,
  GOOGLE_OPTIMIZE_REQUEST_FORM_BLOCKING_API_CALL_TEST_ID,
];

// FIXME(Yuri): Fix type and add condition for undefined
// https://github.com/vercel/next.js/discussions/18991
/**
 * @param {string} testId
 * @param {number} duration
 * @param {boolean} getIsInitialized
 * @returns {(string | null | {variant: string | null, isInitialized: boolean})}
 */
export function useGoogleOptimize(testId, duration, getIsInitialized = false) {
  const [variant, setVariant] = useState(null);
  const [isInitialized, setIsInitialized] = useState(false);
  useEffect(() => {
    const interval = setInterval(() => {
      if (window.google_optimize !== undefined) {
        const variant = window.google_optimize.get(testId);
        if (typeof variant !== 'undefined') setVariant(variant);
        setIsInitialized(true);
        clearInterval(interval);
      }
    }, duration);
  }, []);
  return getIsInitialized ? { variant, isInitialized } : variant;
}

/**
 * @param {string} testId
 */
export function checkActiveExperiment(testId) {
  window.dataLayer.push('event', 'optimize.callback', {
    name: testId,
    callback: (value, name) =>
      // eslint-disable-next-line no-console
      console.log(`Experiment with ID: ${name} is on variant: ${value}`),
  });
}
